import { MaskitoOptions } from '@maskito/core';

export const createSecureCodeMask = (length: null | number): MaskitoOptions => {
  return {
    mask: [...new Array(length ?? 0).fill(/\d/)],
  };
};
